import { FieldTypes } from '../../../constants/FieldTypes'
import { addCondition } from '../../../fields/utils'
import { CheckboxField, FieldMap, FormElement } from '../../../types'
import { FieldEncounterSection } from '../types'
import { generalPhysicalExamField } from './general'
import { pelvicExamField } from './pelvic'

export const hasPhysicalExamField: CheckboxField = {
  type: FieldTypes.CHECKBOX,
  placeholder: 'Physical Exam',
  size: 'lg',
}

export const physicalExamField: FieldMap = {
  name: 'Physical Exam',
  children: {
    general: generalPhysicalExamField,
    pelvic: pelvicExamField,
  },
}

export const getGeneralPhysicalExamSection: (
  optional: boolean,
) => FieldEncounterSection = optional => {
  const children: Record<string, FormElement> = {}
  if (optional) {
    children.hasPhysicalExam = hasPhysicalExamField
    children.physical = addCondition(generalPhysicalExamField, v => !!v?.hasPhysicalExam)
  } else {
    children.physical = generalPhysicalExamField
  }
  return {
    type: 'field',
    field: {
      name: 'General Physical Exam',
      children,
    },
  }
}
